<script>
  import FacetOption from "./FacetOption.svelte";
  import FacetPriceOption from './FacetPriceOption.svelte';
  import FacetPriceSlider from './FacetPriceSlider.svelte';
  import Icon from './Icon.svelte';

  export let facet;
  let isOpen = true;

  const { title, buckets, attribute } = facet;
</script>

<div class={`border-b border-brand-blue w-full mb-m-mobile`}>
  <button
    class={`w-full text-left text-b2 font-body font-bold text-brand-blue flex justify-between items-center py-s ${!isOpen && 'pb-xl-mobile'}`}
    on:click={() => isOpen = !isOpen}
  >
    {title}
    <span class={`transition flex items-center transform-gpu ${isOpen ? 'rotate-180' : 'rotate-0'}`}>
      <Icon icon="small-arrow-down" />
    </span>
  </button>

  <style>
    .drawer-transition {
      transition: max-height 600ms cubic-bezier(0, 0.9, 0, 1);
    }
  </style>

  <ul class={`${!isOpen ? 'overflow-hidden max-h-0 py-0' : 'max-h-[700px] overflow-y-auto mt-s-mobile mb-xl-mobile'} drawer-transition space-y-s`}>
    {#each buckets as option}
      {#if title !== 'Price'}
        <FacetOption {option} {attribute} />
      {:else}
        <FacetPriceSlider />
        <FacetPriceOption />
      {/if}
    {/each}
  </ul>
</div>
